module.exports = __webpack_public_path__ + "media/images/athletes/2213-b9b22a966b7282417a1a77b0d3c63411.png";